module.exports = __webpack_public_path__ + "img/cetak_tagihan.5ddadadb.svg";